/* MH — Buy the look (New Draft, 14 Oct 2026). Markup: snippets/mh-buy-the-look.liquid.
   Opens a drawer (bottom sheet on phones) listing the look; adds every ticked piece in one
   POST /cart/add.js, then refreshes and opens the theme's quick cart. */
(function () {
  if (customElements.get('mh-buy-the-look')) return;

  class MhBuyTheLook extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.mh-btl__panel');
      this.scrim = this.querySelector('.mh-btl__scrim');
      this.addBtn = this.querySelector('[data-btl-add]');
      this.addLabel = this.querySelector('[data-btl-add-label]');
      this.error = this.querySelector('[data-btl-error]');
      this.opener = this.querySelector('[data-btl-open]');
      if (!this.panel || this.moved) return;
      this.moved = true;
      // Lift the drawer out of the product section so the sticky header and page icons cannot sit above it.
      this.panel.classList.add('mh-btl-root'); this.scrim.classList.add('mh-btl-root');
      document.body.append(this.scrim, this.panel);
      this.opener.addEventListener('click', () => this.open());
      [this.scrim, ...this.panel.querySelectorAll('[data-btl-close]')].forEach(el => el.addEventListener('click', () => this.close()));
      this.panel.addEventListener('change', () => this.update());
      this.addBtn.addEventListener('click', () => this.add());
      this.onKey = e => {
        if (e.key === 'Escape') return this.close();
        if (e.key !== 'Tab') return;
        // Keep keyboard focus inside the drawer while it is open (audit 16 Oct 2026)
        const f = [...this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]), select:not([disabled])')].filter(el => el.offsetParent);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
      this.update();
    }

    syncCurrent() {
      // The current product follows the size chosen on the product page (audit 16 Oct 2026)
      const sel = this.panel.querySelector('[data-btl-current]');
      const form = this.closest('form[action*="/cart/add"]') || (this.closest('.shopify-section') || document).querySelector('form[action*="/cart/add"]');
      const id = form && form.querySelector('[name="id"]');
      if (!sel || !id || !id.value) return;
      const opt = [...sel.options].find(o => o.value === id.value && !o.disabled);
      if (opt) sel.value = opt.value;
    }

    open() {
      this.syncCurrent();
      this.update();
      this.scrim.hidden = false;
      this.panel.hidden = false;
      document.documentElement.classList.add('mh-btl-open');
      document.addEventListener('keydown', this.onKey);
      requestAnimationFrame(() => this.panel.classList.add('is-open'));
      this.panel.focus();
    }

    close() {
      this.panel.classList.remove('is-open');
      this.scrim.hidden = true;
      this.panel.hidden = true;
      document.documentElement.classList.remove('mh-btl-open');
      document.removeEventListener('keydown', this.onKey);
      this.opener.focus();
    }

    picked() {
      return [...this.panel.querySelectorAll('[data-btl-item]')]
        .filter(li => li.querySelector('[data-btl-check]').checked)
        .map(li => {
          const v = li.querySelector('[data-btl-variant]');
          const opt = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : null;
          const pre = (opt ? opt.dataset.preorder : v.dataset.preorder) || '';
          const sized = v.value !== '';
          const item = { id: parseInt(v.value, 10), quantity: 1, sized, el: v, name: v.dataset.btlName || '', ok: sized && (!opt || !opt.disabled) };
          // Same line-item property the product page adds for pre-order variants
          if (pre) item.properties = { 'Estimated delivery': pre };
          return item;
        });
    }

    update() {
      // Pre-order note under each piece follows its selected size
      this.panel.querySelectorAll('[data-btl-item]').forEach(li => {
        const v = li.querySelector('[data-btl-variant]');
        const opt = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : null;
        const pre = (opt ? opt.dataset.preorder : v.dataset.preorder) || '';
        const note = li.querySelector('[data-btl-preorder]');
        if (note) { note.hidden = !pre; note.querySelector('[data-btl-preorder-date]').textContent = pre; }
      });
      const items = this.picked();
      const n = items.length;
      this.error.hidden = true;
      this.panel.querySelectorAll('[aria-invalid]').forEach(el => { el.removeAttribute('aria-invalid'); el.removeAttribute('aria-describedby'); });
      // A ticked piece with no size yet keeps the button live; add() then asks for the size (16 Oct 2026, Solene QA)
      this.addBtn.disabled = n === 0 || items.some(i => i.sized && !i.ok);
      this.addLabel.textContent = n === 0 ? 'Add to cart' : `Add to cart (${n})`;
    }

    async add() {
      const unsized = this.picked().find(i => !i.sized);
      if (unsized) {
        this.error.textContent = `Choose a size for ${unsized.name || 'every ticked item'}.`;
        this.error.hidden = false;
        // Tie the error to the select that needs a size, and move focus there (audit 16 Oct 2026)
        const sel = unsized.el;
        if (sel) { sel.setAttribute('aria-invalid', 'true'); sel.setAttribute('aria-describedby', this.error.id); sel.focus(); }
        return;
      }
      const items = this.picked().filter(i => i.ok).map(({ id, quantity, properties }) => (properties ? { id, quantity, properties } : { id, quantity }));
      if (!items.length) return;
      this.addBtn.disabled = true;
      this.addBtn.classList.add('loading');
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        this.close();
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: data }));
        const icon = document.querySelector('[data-js-cart-icon]');
        if (icon) setTimeout(() => icon.click(), 300); else window.location.href = root + 'cart';
      } catch (e) {
        this.error.textContent = e.message;
        this.error.hidden = false;
      } finally {
        this.addBtn.classList.remove('loading');
        this.update();
      }
    }
  }

  customElements.define('mh-buy-the-look', MhBuyTheLook);
})();
